export function getFallbackUrl(fallbackUrl) {
  if (fallbackUrl) {
    return fallbackUrl?.startsWith('/') ? `${window.location.origin}${fallbackUrl}` : fallbackUrl;
  }

  return `${window.location.origin}${window.location.pathname}${window.location.search}`;
}
